import OurFeesCompensationTable from "./OurFeesCompensationTable";

export default OurFeesCompensationTable;
